
class Util {

  debounce = (func: Function, wait: number, immediate: boolean) => {
    let lastTimeout: any;
    const context = this;
    return function () {
      const args = arguments;
      const later = () => {
        lastTimeout = null;
        if (!immediate) {
          func.apply(context, args);
        }
      };
      const callNow = immediate && !lastTimeout;
      clearTimeout(lastTimeout);
      lastTimeout = setTimeout(later, wait);
      if (callNow) {
        func.apply(context, args);
      }
    };
  };

  formatPercent = (count: number, total: number): string => {
    if (total === 0) {
      return `N/A`;
    } else {
      const percent = (100.0 * count) / total;
      return `${percent.toFixed(0)}%`;
    }
  }

  isItemInArray = (itemToCheck: any, items: any[], itemComparator?: any) => {
    return this.indexOfItemInArray(itemToCheck, items, itemComparator) >= 0;
  };

  indexOfItemInArray = (itemToCheck: any, items: any[], itemComparator?: any) => {
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      if (itemComparator) {
        if (itemComparator(item, itemToCheck)) {
          return i;
        }
      } else {
        if (item === itemToCheck) {
          return i;
        }
      }
    }
    return -1;
  };

  // isEntityInArray = (entity: Entity, entities: Entity[]): boolean => {
  //   for (const e of entities) {
  //     if (e.key === entity.key) {
  //       return true;
  //     }
  //   }
  //   return false;
  // }

  // doEntityArraysMatch = (entitiesA: Entity[], entitiesB: Entity[]): boolean => {
  //   if (entitiesA.length === entitiesB.length) {
  //     for (const entityA of entitiesA) {
  //       if (!this.isEntityInArray(entityA, entitiesB)) {
  //         return false;
  //       }
  //     }
  //     for (const entityB of entitiesB) {
  //       if (!this.isEntityInArray(entityB, entitiesA)) {
  //         return false;
  //       }
  //     }
  //     return true;
  //   } else {
  //     return false;
  //   }
  // }

  insecureHash = (text: string): string => {
    let hash = 0;
    for (let i = 0; i < text.length; i++) {
      const char = text.charCodeAt(i);
      hash = (hash << 5) - hash + char;
      hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([hash])[0].toString(36);
  }

  formatNumber = (myNumber: number): string => {
    if (myNumber.toLocaleString) {
      return myNumber.toLocaleString();
    } else {
      return `${myNumber}`;
    }
  }

  nameToSlug(name: string): string {
    const slug = name.toLowerCase().replaceAll(' ', '-');
    return slug
  }

  uuid4 = () => {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }

  uuid = () => {
    const s4 = this.uuid4;
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
      s4() + '-' + s4() + s4() + s4();
  };

}

export default new Util();

function base64FromBase64Url(base64Url: string) {
  return (base64Url + '==='.slice((base64Url.length + 3) % 4))
    .replace(/-/g, '+')
    .replace(/_/g, '/');
}

export function utf8StringFromBase64Url(base64Url: string) {
  return Buffer.from(base64FromBase64Url(base64Url), 'base64').toString('utf8');
}

export function base64Url(string: string) {
  return Buffer
    .from(string, 'utf-8')
    .toString('base64')
    .replace(/=/g, '')
    .replace(/\+/g, '-')
    .replace(/\//g, '_');
}
